import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const ComboBox = (props) => {
  const { label, onChange, value, ...otherProps } = props;
  const _onChange = (_, value) => {
    onChange(value);
  };
  return (
    <Autocomplete
      {...otherProps}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={props.options}
      renderInput={(inputProps) => <TextField {...inputProps} label={label} />}
      onChange={_onChange}
      value={value}
    />
  );
};

export default ComboBox;
